import { render, staticRenderFns } from "./content-edit-recomendation.vue?vue&type=template&id=4001bf26&"
import script from "./content-edit-recomendation.vue?vue&type=script&lang=js&"
export * from "./content-edit-recomendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports